import React, {Component} from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import {Container, Header, Segment, Image, Grid,Card, Icon} from 'semantic-ui-react';
const coverImage = require('../assets/img/desk.jpg');
const cupImage = require('../assets/img/cup.png');
const clientsImage = require('../assets/img/clientes.png');
const coverStyle = {
  backgroundColor: '#70B188',
  backgroundImage: `url(${coverImage})`,
  backgroundSize: 'cover',
  backgroundAttachment: 'fixed'
};
const mainSegmentStyle = {
  height: '70vh',
  background: 'rgba(0,0,0,0)',
  backgroundColor: 'hsl(0, 0%, 100%)',
  mixBlendMode: 'screen',
  marginBottom: '50vh'
};
const headerStyle = {
  textTransform: 'uppercase',
  textShadow: 'rgb(152, 152, 152) 9px 4px 0px',  
  color: 'black',

  position: 'absolute',
  bottom: 20,
  width: '100%',
  left: 0,
  right: 0
};
const subheaderStyle = {
  color: 'black',
  textShadow: 'none'
};
const secondaryHeaderStyle = {
  color: 'orange',
  display: 'inline-block',

};
const textStyle = {
  fontSize: '16pt'
}
class SupportView extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (

        <Container fluid style={coverStyle}>
        <Segment size="massive" textAlign="center" basic className="coversegment">
        <Header as="h1" style={headerStyle}>
          
          <Header.Subheader style={subheaderStyle}>
            Desde Argentina al Mundo
          </Header.Subheader>
          Nosotros
        </Header>
      </Segment>
          <Grid
            padded
            relaxed
            stackable
            style={{
            backgroundColor: 'white'
          }}>
            <Grid.Row>
              <Grid.Column width={16}>
              <Segment textAlign="right" basic size='big'>
              <center>
              <p className="textblock">
              Sistel Argentina fue creada por un grupo de Ingenieros en Sistemas de
              Información, creando de esta manera la primer empresa integral de desarrollo de
              soluciones en la región.
              </p>
              <p className="textblock">
              Basados en la integración de aplicativos, tanto con sistemas preexistentes como con
              las herramientas ofimáticas de su empresa, buscamos crear una solución a
              medida, general e integral a sus necesidades de información, aprovechando sus
              recursos propios e incorporando tecnología de punta, partiendo de la base de la
              generación de un compromiso entre el cliente y su proveedor de soluciones.
              </p>
              <p className="textblock">
              Con herramientas de última generación, con desarrollos basados en tecnología
              visual, para aplicaciones client/server, buscamos generar la mas completa y
              eficiente red de información en su empresa, orientada en todo momento a la
              satisfacción de las necesidades gerenciales y de alta dirección, apoyando la correcta
              toma de decisiones institucionales, y poniendo la experiencia adquirida por nuestra
              empresa en el tratamiento tanto de los organismos públicos como de las empresas
              privadas.
              </p>
              <p className="textblock">
              Desde ya, y agradeciendo su atención, ponemos todo nuestro potencial a su
              alcance.
              </p>
              </center>
          </Segment>
          
          <Segment basic padded='very' size='large'>
              <Card.Group stackable itemsPerRow={3}>
                  <Card>

                      <Card.Content>
                        <Card.Header>
                          Eduardo Matusevich
                        </Card.Header>
                        <Card.Meta>
                          <span className='date'>
                            Fundador, 1997
                          </span>
                        </Card.Meta>
                        <Card.Description>
                          
                        </Card.Description>
                      </Card.Content>
                      <Card.Content extra>
                        <a>
                          <Icon name='location' />
                          Corrientes, AR
                        </a>
                      </Card.Content>
                  </Card>
                  <Card>

                      <Card.Content>
                        <Card.Header>
                          Mercedes Kamijo
                        </Card.Header>
                        <Card.Meta>
                          <span className='date'>
                            Miembro desde 2004
                          </span>
                        </Card.Meta>
                        <Card.Description>
                          
                        </Card.Description>
                      </Card.Content>
                      <Card.Content extra>
                        <a>
                          <Icon name='location' />
                          Corrientes, AR
                        </a>
                      </Card.Content>
                  </Card>
                  <Card>

                      <Card.Content>
                        <Card.Header>
                          Gabriel Matusevich
                        </Card.Header>
                        <Card.Meta>
                          <span className='date'>
                            Miembro desde 2014
                          </span>
                        </Card.Meta>
                        <Card.Description>
                          
                        </Card.Description>
                      </Card.Content>
                      <Card.Content extra>
                        <a>
                          <Icon name='location' />
                          Corrientes, AR
                        </a>
                      </Card.Content>
                  </Card>
                  <Card>

                      <Card.Content>
                        <Card.Header>
                          Javier Matusevich
                        </Card.Header>
                        <Card.Meta>
                          <span className='date'>
                            Miembro desde 2016
                          </span>
                        </Card.Meta>
                        <Card.Description>
                          
                        </Card.Description>
                      </Card.Content>
                      <Card.Content extra>
                        <a>
                          <Icon name='location' />
                          Mar del Plata, AR
                        </a>
                      </Card.Content>
                  </Card>
              </Card.Group>

          </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
                    <div style={{margin: '5px', textAlign: "center", color: "white"}}><strong>Teniente Cundom 1574 - Corrientes - Argentina</strong></div>
        </Container>
      
    );
  }
}

export default SupportView;




// WEBPACK FOOTER //
// ./client/containers/AboutView.js